import React from 'react'
type AppProps={
    onlinePresence:any;
    setClientBasicDetails: (data: any) => void;
    isDisabled?:boolean
}
const OnlinePresence = ({
    onlinePresence,
    setClientBasicDetails,
    isDisabled
}:AppProps) => {
    const handleonlinePresenceDetailsChange=(data:any)=>{
       setClientBasicDetails((prev:any)=>{
           return{
               ...prev,
               onlinePresence:{
                   ...prev.onlinePresence,
                   [data.target.name]:data.target.value
               }
           }
       })
   }
    return (
        <div className='row mb-5'>
            <div className="col-md-3">
                <label htmlFor="skype">Skype</label>
                <div >
                    <input
                        type="text"
                        className={`form-control`}
                        name="skype"
                        onChange={handleonlinePresenceDetailsChange}
                        value={onlinePresence?.skype}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            <div className="col-md-3">
                <label htmlFor="linkedIn">LinkedIn</label>
                <div >
                    <input
                        type="text"
                        className="form-control"
                        name="linkedIn"
                        onChange={handleonlinePresenceDetailsChange}
                        value={onlinePresence?.linkedIn}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            <div className="col-md-3">
                <label htmlFor="twitter">Twitter</label>
                <div >
                    <input
                        type="text"
                        className="form-control"
                        name="twitter"
                        onChange={handleonlinePresenceDetailsChange}
                        value={onlinePresence?.twitter}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            <div className="col-md-3">
                <label htmlFor="website">Website</label>
                <div >
                    <input
                        type="text"
                        className="form-control"
                        name="website"
                        onChange={handleonlinePresenceDetailsChange}
                        value={onlinePresence?.website}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        </div>
    )
}

export default OnlinePresence